import Text from '../../../atoms/Text';
import Button from '../../../molecules/Button';
import { LS_APP_VERSION } from '../../../hooks/useCacheBuster';

import './styles.scss';

interface IUpdateAppModalProps {
  actionCloseModal: () => void;
}

const UpdateAppModal = ({ actionCloseModal }: IUpdateAppModalProps) => {
  const refreshCacheAndReload = async () => {
    if (window.localStorage) {
      console.log('Clearing cache and hard reloading...');
      // Set previous app version as the latest one
      localStorage.setItem(
        LS_APP_VERSION,
        // eslint-disable-next-line no-undef
        process.env.REACT_APP_COMMIT_HASH || ''
      );
      // delete browser cache and hard reload
      // the process will be to get the url without cache first and then reload the page:
      const url = window.location.href;
      await fetch(url, {
        headers: {
          Pragma: 'no-cache',
          Expires: '-1',
          'Cache-Control': 'no-cache',
        },
      });
      window.location.href = url;
      // This is to ensure reload with url's having '#'
      window.location.reload();
    }
  };

  return (
    <div className='update_app'>
      <div
        className='update_app__close icon-close'
        onClick={actionCloseModal}
      />
      <div className='update_app__description'>
        <Text size={16} className='text--grey-200 text--weight-500'>
          Update arrived
        </Text>
        <Text size={14} className='text--grey-400 text--weight-500'>
          A new version of the frontend is available.
        </Text>
      </div>
      <div className='update_app__action'>
        <Button
          size='s'
          variant='primary'
          action={refreshCacheAndReload}
          text='Update'
        />
      </div>
    </div>
  );
};

export default UpdateAppModal;
